// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pmHo","col":"styles_col__1_Pmn"};